<template>
    <div class="row">
        <div class="col-md-6">
            <h4>Create Validation Rules</h4>
            <table class="table table-bordered table-hover">
                <tr>
                    <th>#</th>
                    <th>Validation Rule</th>
                </tr>
                <tr v-for="(item, index) in inputs" v-bind:key="index">
                    <td>
                        {{item}}
                    </td>
                    <td>
                        <div>
                            <div class="form-group  m-form__group row">
                                <div class="col-lg-10" v-for="(option, key, index2) in createRules" v-bind:key="index2" v-if="(option.key == item)">
                                    <div class="form-group m-form__group row align-items-center">
                                        <div class="col-md-5">
                                            <div class="m-form__group m-form__group--inline">
                                                <div class="m-form__label">
                                                    <label>
                                                        Validation name:
                                                    </label>
                                                </div>
                                                <div class="m-form__control">
                                                    <select class="form-control" v-model="option.value" v-on:blur="updateDatas" v-on:change="updateDatas">
                                                        <option value="active_url">Active URL</option>
                                                        <option value="alpha_num">Alpha Numeric</option>
                                                        <option value="boolean">Boolean</option>
                                                        <option value="email">Email</option>
                                                        <option value="file">File</option>
                                                        <option value="image">Image</option>
                                                        <option value="integer">Integer</option>
                                                        <option value="ip">IP address</option>
                                                        <option value="json">JSON</option>
                                                        <option value="max:">Max:value</option>
                                                        <option value="min:">Min:value</option>
                                                        <option value="numeric">Numeric</option>
                                                        <option value="regex:">Regex:pattern</option>
                                                        <option value="required">Required</option>
                                                        <option value="same:">Same:field</option>
                                                        <option value="string">String</option>
                                                        <option value="unique">Unique</option>
                                                        <option value="url">Url</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="d-md-none m--margin-bottom-10"></div>
                                        </div>
                                        <div class="col-md-5" v-if="passRules(option.value)">
                                            <div class="m-form__group m-form__group--inline">
                                                <div class="m-form__label">
                                                    <label class="m-label m-label--single">
                                                        Validation rule:
                                                    </label>
                                                </div>
                                                <div class="m-form__control">
                                                    <input type="text" class="form-control m-input" v-model="option.value2" v-on:keyup="updateDatas">
                                                </div>
                                            </div>
                                            <div class="d-md-none m--margin-bottom-10"></div>
                                        </div>
                                        <div class="col-md-2">
                                            <div  class="btn-sm btn btn-danger m-btn m-btn--icon m-btn--pill" @click="deleteRepeater(1, key, item)">
                                                <span>
                                                   <i class="la la-trash-o"></i>
                                                   <span>
                                                      Delete
                                                   </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="m-form__group form-group row">
                                <label class="col-lg-2 col-form-label"></label>
                                <div class="col-lg-4">
                                    <div class="btn btn btn-sm btn-brand m-btn m-btn--icon m-btn--pill m-btn--wide" @click="repeaterCreate(1, item)">
                                          <span>
                                             <i class="la la-plus"></i>
                                             <span>
                                                Add
                                             </span>
                                          </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="col-md-6">
            <h4>Update Validation Rules</h4>
            <table class="table table-bordered table-hover">
                <tr>
                    <th>#</th>
                    <th>Validation Rule</th>
                </tr>
                <tr v-for="(item, index) in inputs" v-bind:key="index">
                    <td>
                        {{item}}
                    </td>
                    <td>
                        <div>
                            <div class="form-group  m-form__group row">
                                <div class="col-lg-10" v-for="(option, key, index2) in updateRules" v-bind:key="index2" v-if="(option.key == item)">
                                    <div class="form-group m-form__group row align-items-center">
                                        <div class="col-md-5">
                                            <div class="m-form__group m-form__group--inline">
                                                <div class="m-form__label">
                                                    <label>
                                                        Validation name:
                                                    </label>
                                                </div>
                                                <div class="m-form__control">
                                                    <select class="form-control" v-model="option.value" v-on:blur="updateDatas" v-on:change="updateDatas">
                                                        <option value="active_url">Active URL</option>
                                                        <option value="alpha_num">Alpha Numeric</option>
                                                        <option value="boolean">Boolean</option>
                                                        <option value="email">Email</option>
                                                        <option value="file">File</option>
                                                        <option value="image">Image</option>
                                                        <option value="integer">Integer</option>
                                                        <option value="ip">IP address</option>
                                                        <option value="json">JSON</option>
                                                        <option value="max:">Max:value</option>
                                                        <option value="min:">Min:value</option>
                                                        <option value="numeric">Numeric</option>
                                                        <option value="regex:">Regex:pattern</option>
                                                        <option value="required">Required</option>
                                                        <option value="same:">Same:field</option>
                                                        <option value="string">String</option>
                                                        <option value="unique">Unique</option>
                                                        <option value="url">Url</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="d-md-none m--margin-bottom-10"></div>
                                        </div>
                                        <div class="col-md-5" v-if="passRules(option.value)">
                                            <div class="m-form__group m-form__group--inline">
                                                <div class="m-form__label">
                                                    <label class="m-label m-label--single">
                                                        Validation rule:
                                                    </label>
                                                </div>
                                                <div class="m-form__control">
                                                    <input type="text" class="form-control m-input" v-model="option.value2" v-on:keyup="updateDatas">
                                                </div>
                                            </div>
                                            <div class="d-md-none m--margin-bottom-10"></div>
                                        </div>
                                        <div class="col-md-2">
                                            <div  class="btn-sm btn btn-danger m-btn m-btn--icon m-btn--pill" @click="deleteRepeater(2, key, item)">
                                                <span>
                                                   <i class="la la-trash-o"></i>
                                                   <span>
                                                      Delete
                                                   </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="m-form__group form-group row">
                                <label class="col-lg-2 col-form-label"></label>
                                <div class="col-lg-4">
                                    <div class="btn btn btn-sm btn-brand m-btn m-btn--icon m-btn--pill m-btn--wide" @click="repeaterCreate(2, item)">
                                          <span>
                                             <i class="la la-plus"></i>
                                             <span>
                                                Add
                                             </span>
                                          </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Validation',
  props: {
    inputs: {
      required: true
    },
    createRules: {
      type: Array,
      required: true
    },
    updateRules: {
      type: Array,
      required: true
    }
  },
  methods: {
    passRules: function (val) {
      if (val === 'max:' || val === 'min:' || val === 'regex:' || val === 'same:') {
        return true
      }
      return false
    },
    repeaterCreate: function (type, input) {
      if (type === 1) {
        this.createRules.push({key: input, value: 'required', value2: ''})
      } else {
        this.updateRules.push({key: input, value: 'required', value2: ''})
      }
      this.updateDatas()
    },
    deleteRepeater: function (type, key, input) {
      if (type === 1) {
        this.createRules.splice(key, 1)
      } else {
        this.updateRules.splice(key, 1)
      }
      this.updateDatas()
    },
    updateDatas: function () {
      this.$emit('createRules', this.createRules)
      this.$emit('updateRules', this.updateRules)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/module/Validation.vue